import Contato from "../../components/Contato";

function ContatoPage () {

  return (
    <Contato />
  )
}

export default ContatoPage;